"use client";

import { SiteTemplatePageSectionTypeFaqSettingModel } from "@/Apis/ClinicApi";
import { Helper } from "@/Helpers";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { FaqSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedFaqSection from "../Components/GeneratedFaqSection";

const Faq: FC<FaqSectionProps> = (props) => {
  return <GeneratedFaqSection {...props} />;
};

export default Faq;

export const defaultFaqSetting: SiteTemplatePageSectionTypeFaqSettingModel = {
  Title: "",
  Description: "",
  Image: { Id: 0, Name: "", Size: 0 },
  Appearance: Helper.centerOptionObjectToCenterOptionModel(
    CenterOptions.SiteTemplate.SiteTemplateSettings.SiteTemplateFaqAppearance
      .Home1,
  ),
};
